import HttpRequest from '@/utils/fetchVrs'

/**
 * 日志记录
 */
class VrsHttp extends HttpRequest {
    
    /**
     * 发送打点请求
     * @param data 
     */
    sendVrsLog(data) {
        let options = {
            url: "/record/v3/viewPoint",
            method: "POST",
            data: {
                viewData: data
            }
        }
        return this.request(options)
    }

}

export default VrsHttp